// import { TR } from "../main";

class Translation {
  static ro = {
    Locale: "ro",
    VAT_GROUP_COUNT: 6,
    VAT_GROUP_1: "A",
    VAT_GROUP_2: "B",
    VAT_GROUP_3: "C",
    VAT_GROUP_4: "D",
    VAT_GROUP_5: "E",
    VAT_GROUP_6: "AlteTaxe",
    MoneyAbbreviation: "ron",
    Currency: "Valuta",
    HourAbbreviation: "h.",
    EU: "€",
    Yes: "Da",
    No: "Nu",
    OK: "ОК",
    Append: "Aplica",
    Clear: "Curata",
    More: "Mai mult",
    Less: "Mai putin",
    Error: "Eroare",
    Attention: "Atentie",
    Info: "Info",
    Important: "Important",
    Warning: "Atentie",
    Urgent: "Urgent",
    None: "Nici unul",
    Number: "Numar",
    Today: "Astazi",
    Yesterday: "Ieri",
    TheWeek: "Saptamana",
    ThisMonth: "Luna aceasta",
    PreviousMonth: "Luna trecuta",
    IsBetween: "este intre",
    Contains: "contine",
    Sales: "Vanzari",
    SalesByItems: "Vanzari pe Articole",
    SalesByPrices: "Vanzari pe Preturi",
    SaleDate: "Data Vanzare",
    PaymentTypesByDays: "Moduri Plata pe zile",
    PaymentType: "Mod Plata",
    PaymentSum: "Valoare Plata",
    Receipts: "Bonuri",
    ReceiptsCount: "Total bonuri",
    ReceiptNumber: "Numar Bon",
    Article: "Articol",
    Department: "Departament",
    Backward: "Inapoi",
    Finish: "Finalizat",
    Settings: "Setari",
    Active: "Activa",
    Stopped: "Oprita",
    Forward: "Inainte",
    Login: "Logare",
    Logging: "Logare in aplicatie….",
    Logout: "Iesire",
    View: "Vedere",
    Alarms: "Alerte",
    Continue: "Continua",
    Format: "Format",
    Period: "Perioada",
    Columns: "Coloane",
    Export: "Export",
    Download: "Descarca",
    TaxGr: "Cota TVA",
    TaxGroup: "Cota TVA",
    Turnover: "Rulaj",
    SalesCount: "Numar Tranzactii",
    AverageDaily: "Mediu zilnic",
    TurnoverByTaxGroups: "Rulaj pe cote TVA",
    TurnoverByDays: "Rulaj pe zile",
    TurnoverByHours: "Rulaj pe ore",
    TurnoverByHoursForTheDay: "Rulaj pe ore din zi",
    ActivityByHours: "Activitate pe ore",
    TotalTurnover: "Rulaj total",
    Payments: "Plati",
    Type: "Tip",
    Recipient: "Destinatar",
    Client: "Client",
    Address: "Adresa",
    Customer: "Client",
    CustomerMolName: "Reprezentant client",
    ClientInfo: "Date Client",
    VAT: "TVA",
    ZDDS: "TVA",
    IdentN: "Nr. Identificare",
    FM: "MF",
    UNP: "UNP",
    User: "Utilizator",
    Username: "Nume Utilizator",
    Email: "E-mail",
    From: "De la",
    To: "Catre",
    Value: "Valoare",
    Values: "Valori",
    Add: "Plus",
    Total: "Total",
    Subtotal: "Subtotal",
    Addition: "Adaos",
    Discount: "Discount",
    Original: "Original",
    ForInvoiceN: "La Factura Nr.",
    CreditNoteNumber: "Nota de Credit",
    ReceiptInfo: "Informatii BON",
    IssueReason: "Motiv creere",
    Balance: "Credit",
    NoBalance: "Credit insuficient",
    CurrentBalance: "Credit curent",
    BalancePay: "Incarcare",
    Bonus: "Bonus",
    BonusAccumulated: "Bonus acumulat",
    BonusUnused: "Bonus acumulat si nefolosit din platile catre TREMOL Assitant pentru Clienti.",
    BonusPayment: "Bonus incarcare cont",
    BalancePayment: "Bonus incarcare cont",
    Charging: "Incarcare",
    ChargingDaily: "Incarcare zilnica",
    Password: "Parola",
    CurrentPassword: "Parola curenta",
    ForgottenPassword: "Parola uitata",
    NewPassword: "Parola noua",
    ConfirmPassword: "Confirma Parola",
    Confirmation: "Confirmare",
    ChangePassword: "Schimbare Parola",
    Profile: "Profil",
    PasswordMin6Symbols: "Parola trebuie sa aibe minim 6 simboluri",
    PasswordMin6Max30Symbols: "Parola trebuie sa aibe minimum 6 si maxim 30 simboluri",
    PasswordRequired: "Va rugam, introduceti parola",
    PasswordNewRequired: "Introduceti parola noua",
    PasswordsDoesntMatch: "Parolele introduse nu sunt la fel",
    PasswordChangedSuccessfully: "Parola schimbata cu succes",
    CompanyName: "Nume Firma",
    CompanyEIK: "CUI",
    MoneyInOut: "Sume de serviciu",
    InfoReceipt: "Diagnoza",
    Duplicate: "Duplicat",
    Storno: "Storno",
    StornoReceipt: "Bon Storno",
    StornoTurnover: "Rulaj Storno",
    CreditNode: "Nota de Credit",
    FUVASEvent: "APARAT evenimente",
    FUVASButtonEvent: "Colectare numerar",
    DeviceStatus: "Status APARAT",
    AuditAuto: "Audit automat",
    AuditInfoAuto: "Informatie audit (automata)",
    AuditInfoManual: "Informatie audit (manuala)",
    FiscalizationReceipt: "BON Fiscalizare",
    FiscalReceipt: "BON Fiscal",
    LastReceipt: "Bon Ultima",
    AutoReload: "Reincarcare automata date live",
    Invoice: "Factura",
    Document: "Document",
    Legend: "Legenda",
    Sum: "Suma",
    EIK: "CUI",
    MOL: "Delegat",
    MOLorAuthorizedPerson: "Delegat sau persoana autorizata",
    Price: "Pret",
    PriceForOne: "Pret unitar",
    PriceForMonth: "Pret lunar pe aparate",
    Date: "Data",
    Hour: "Ora",
    Quantity: "Cantitate",
    Void: "Anulare",
    Message: "Mesaj",
    V_O_I_D: "A N U L A R E",
    S_T_O_R_N_O: "S T O R N O",
    Voided: "Anulat",
    InCash: "Numerar",
    Card: "Card",
    TotalSum: "Suma Totala",
    TOTALSUM: "SUMA TOTALA",
    Operator: "Operator",
    Operations: "Operatii",
    Status: "Status",
    Cancel: "Anulare",
    Search: "Cautare",
    Sort: "Filtrare",
    Subscription: "Abonament",
    Activate: "Activeaza",
    ActivatePlan: "Activeaza plan",
    Deactivate: "Dezactiveaza",
    DeactivatePlan: "Dezactiveaza Plan",
    CurrentPlan: "Plan Curent",
    ConfirmRequest: "Confirmati modificarile pentru",
    Comment: "Observatie",
    DevComment: "AP obs",
    Change: "Modificari",
    Contract: "Contract",
    ContractTo: "Contract pana la",
    ActiveSim: "SIM card activ",
    Settlement: "Setelment",
    Street: "Strada",
    SubscriptionPlan: "Plan abonament",
    ChangePlan: "Moficare abonament",
    ChoosePlan: "Alegere abonament",
    ChooseAll: "Alege tot",
    ChooseDevices: "Alege aparate",
    SimStatus: "Status SIM",
    Choice: "Alegere",
    NoData: "Date lipsa",
    Data: "Date",
    Filters: "Filtre",
    Action: "Actiune",
    Dev: "AP",
    Device: "Aparat",
    Devices: "Aparate",
    AllDevices: "Toate APARATELE",
    AllDevs: "Toate AP",
    Product: "Produs",
    Ingredient: "Ingedient",
    ReceiptType: "Tip BON",
    ReceiptDate: "DATA BON",
    FMNum: "NUI",
    DevSN: "Serie AP",
    FDRID: "FDRID",
    SN: "Serie",
    KLEN: "JE",
    Event: "Eveniment",
    Technician: "Tehnician",
    Seen: "Vazut",
    DevNumber: "Nr. AP",
    Model: "Model",
    Missing: "Lipsa",
    Company: "Firma",
    Name: "Nume",
    Surname: "Prenume",
    LastName: "Prenume",
    PSN: "Т.О.",
    PCS: "buc",
    Description: "Descriere",
    ItemName: "Nume Articol",
    DefaultItem1: "Cafea",
    DefaultItem2: "Ceai",
    DefaultItem3: "Capucino",
    DefaultItem4: "Lapte",
    DefaultItem5: "Croissant",
    DefaultItem6: "Napolitana",
    DefaultItem7: "Sticsuri",
    DefaultItem: "Chiftea",
    SearchSort: "Cautare / Filtrare",
    SearchByNameOrSN: "Cautare dupa Nume sau Serie",
    PSName: "Nume Locatie",
    YearAndMonth: "Luna si An",
    Year: "An",
    Month: "Luna",
    DayFromTheWeek: "Zi din saptamana",
    DevsCount: "Numar aparate",
    ChosenDevsFor: "Aprate selectate pentru",
    CurrentlyChosenDevs: "Aparate selctate",
    TotalChosenDevs: "Total aparate in abonament",
    TotalDevs: "Total aparate",
    NothingChosen: "Nici o selectie!",
    DataNotFound: "Nu au fost gasite date pe baza criteriului",
    Device_Name: "Nume AP",
    Device_Info: "Detalii aparate",
    CapsTooltip_CapsON: "Caps Lock еste apasat!",
    Online: "Online",
    Offline: "Offline",
    NoSubscription: "Dezabonat",
    Blocked: "Blocat",
    NoProfile: "Inactiv",
    BLOCK_TEXT: "APARAT blocat",
    FM_FULL_TEXT: "MF Plina",
    FM_NEAR_FULL_TEXT: "Raman mai putin de 50 de inregistrari in MF",
    ReceiveDate: "Data primire",
    DGVColumnSelector_ChooseColumns: "Selectie coloane",
    BlockedDevs: "Aparate blocate",
    Location: "Locatie",
    Title: "Titlu",
    Column: "Coloana",
    Version: "Versiune",
    Phone: "Telefon",
    DarkMode: "Mod DARK",
    DenseMode: "Tabele restranse",
    ListDevs: "Lista AP",
    Save: "Salvare",
    SaveChanges: "Salvare modificari",
    SaveSuccessful: "Salvare cu succes",
    AddSuccessful: "Adaugare cu succes",
    EditSuccessful: "Modificare cu succes",
    DeleteSuccessful: "Stergere cu succes",
    EditInfo: "Editare",
    ForTheDay: "Pt. Ziua",
    ForTheWeek: "Pt. Saptamana",
    ForTheMonth: "Pt. Luna",
    ForTheYear: "Pt. Anul",
    ReportReceipts: "Raport Bonuri Zi",
    DevsWithoutSaleReports: "Acest Aparat nu suporta citiri la distanta",
    InnerMessages: "Mesaje intrate",
    DeviceList: "Lista Aparate",
    DeviceList_Sort: "Filtrare",
    DeviceList_ChooseAllDevs: "Selectie toate dispozitivele",
    DeviceList_NoDevsFound: "Nu s-au gasit dispozitive",
    DeviceList_AddressAsc: "Adresa crescatoare ↓",
    DeviceList_AddressDesc: "Adresa descrescatoare ↑",
    DeviceList_NameAsc: "Nume AP crescator ↓",
    DeviceList_NameDesc: "Nume AP descrescator ↑",
    DeviceList_SnAsc: "Seria AP crescator ↓",
    DeviceList_SnDesc: "Seria AP descrescator ↑",
    DeviceInformation_DailyTurnoverAsc: "Rulaj zilnic crescator ↓",
    DeviceInformation_DailyTurnoverDesc: "Rulaj zilnic descrescator ↑",
    DeviceInformation_WeeklyTurnoverAsc: "Rulaj saptamanal crescator ↓",
    DeviceInformation_WeeklyTurnoverDesc: "Rulaj saptamanal descrescator ↑",
    DeviceList_NameAsc_mobile: "Nume AP cresc ↓",
    DeviceList_NameDesc_mobile: "Nume AP desc ↑",
    DeviceList_SnAsc_mobile: "Serie cresc ↓",
    DeviceList_SnDesc_mobile: "Serie desc ↑",
    DeviceInformation_DailyTurnoverAsc_mobile: "Zilnic cresc ↓",
    DeviceInformation_DailyTurnoverDesc_mobile: "Zilnic desc ↑",
    DeviceInformation_WeeklyTurnoverAsc_mobile: "Saptamanal cresc ↓",
    DeviceInformation_WeeklyTurnoverDesc_mobile: "Saptamanal desc ↑",
    PleaseChooseDevices: "Alegeti Aparate",
    PleaseChooseTechnician: "Alegeti Operator",
    LoadingOf: "Incarcare",
    ForPeriod: "Petru perioada",
    PleaseWait: "va rugam asteptati...",
    LoadingView_LoadingInfo: "Incarcare informatie...",
    LoadingDataPleaseWait: "Incarcare date, asteptati...",
    LoadingReportsPleaseWait: "Incarcare Rapoarte, asteptati...",
    LoadingSalesPleaseWait: "Incarcare vanzari, asteptati...",
    LoadingLastSalesPleaseWait: "Incarcare ultimele vanzari,asteptati...",
    ExportingDataPleaseWait: "Datele sunt exportate...",
    ErrorOnExport: "Eroare la export",
    ServerError: "Eroare server",
    ServerNoConnection: "Lipsa conexiune server",
    ErrorUnknown: "Eroare",
    NoDevsSubscribed: "In acest moment nu aveti aparate cu abonament",
    NoDevsSubscribedForThisData: "Nu aveti Aparate abonate pentru acest tip de date",
    PleaseSubscribeDevs: "Includeti in abonament, Aparatele pentru care vreti servicii ",
    RedirectToSubscription: "O sa fiti trimis in meniul abonamente pentru a continua abonarea",
    RemainingTrialDays: "Zile ramase perioada de proba",
    Notifications_Unread: "Mesaje necitite",
    Notifications_NoNotifications: "Lipsa notificari",
    Picker_Chosen: "Alese",
    PriceWithVat: "Pret cu TVA",
    SubscriptionPlan_PricePerDay: "Ron pe ZI",
    PricePerMonth: "Ron pe luna",
    Captcha_WrongInput: "Valoare introdusa este gresita!",
    DevWithStoppedSim: "Aparatul are SIM oprit!",
    NoOnlineReports: "Aceste modele de AMEF nu permit raportarea la distanta!",
    DataProcessingPleaseWait: "Datele sun in curs de procesare, asteptati va rog...",
    LocationsFound: "Locatii gasite",
    EditLocations: "Editare locatii",
    Map_DevInstruction: "Instructiuni de folosire",
    Map_DevEditAddress: "Input device address.",
    Map_ShowInGoogleMaps: "Deschide in Google maps",
    Map_ClickAndEdit: "Apasati pe iconita corespunzatoare AP, pentru a modifica locatia, tineti apasat buton si miscati mouse.",
    LastActivity: "Ultima Activitate",
    ZReportReceived: "A primit raportul Z",
    ShowLastReceipt: "Afiseaza ultimul bon pe AP",
    NewSale: "Vanzare Noua",
    NoFilteredDevsForActivating: "Nu exista AP cu criteriile introduse, care pot fi activate.",
    NoFilteredDevsForDeactivating: "Nu exista AP cu criteriile introduse, care pot fi dezaactivate.",
    NoDevsForActivating: "Nu exista AP, care sa aibe abonament.",
    NoDevsForDeactivating: "Nu exista AP pentru care se termina abonamentul.",
    PriceDailyFor: "Pret zilnic pentru ",
    PriceMonthlyFor: "Pret pe 30 zile pentru",
    PriceYearlyFor: "Pret pe 365 zile pentru",
    PriceFreeTrial: "Pret curent pentru perioada de proba",
    SendingSubscriptionRequestPleaseWait: "Trimitere cerere abonament, va rog asteptati...",
    SuccessfulSubscription: "Abonament creat cu succes!",
    DiscountForDevCount: "Reducere pe cont, in fuctie de numarul de Aparate ",
    WhenSubscribing: "La abonarea la",
    PercentDiscount: "Procent reducere",
    IfIPay: "Daca platesc",
    PayedTo: "Platit la",
    ToWorkUntil: "Ca sa functionez pana la",
    PleaseChooseSubscriptionPlan: "Va rog, alegeti planul de abonament pentru cel putin un AP",
    TheBalanceWillBeUntil: "Soldul o sa ajunga pana la",
    IsNecessaryToPay: "e necesar sa platesc",
    DevPriceForDay: "Consum 1 AP pentru o zi",
    MonthlyPrice: "Cost lunar",
    ConsumptionForDay: "Consum zilnic",
    ConsumptionFor30Days: "Consum 30 zile (rotunjit)",
    ConsumptionFor365Days: "Consum pentru 365 zile (rotunjit)",
    NoDataForShowing: "Nu sunt date",
    NoInvoice: "Nu a fost emisa factura",
    ErrorWhileLoadingInvoice: "Eroare la incarcare factura",
    Read: "Citit",
    NotRead: "Ne citit",
    MarkRead: "Marcare citit",
    MarkNotRead: "Marcare necitit",
    FilterBy: "Filtrare dupa",
    FilterBySubject: "Filtrare dupa subiect",
    FilterByType: "Filtrare dupa tip",
    NoMessagesReceived: "Nu aveti mesaje primite",
    NoMessagesFound: "Nu aveti mesaje",
    ContactPhone: "Telefon contact",
    FuvasEvents: "Evenimente Aparat",
    ShowClockWithDates: "Afisare ore la alegerea perioadei",
    ShowTooltips: "Afisare texte ajutor",
    ExampleTooltip: "Afisare texte exemplu",
    DontShowOldModels: "Nu afisa modele vechi de AP",
    StartPage: "Pagina initiala",
    NotificationEmail: "E-mail evenimente Aparat",
    InvalidPhone: "Telefon contact invalid!",
    NoRecordsFound: "Nu exista inregistrari",
    DevicesNotChosen: "Nu exista AP selectate",
    PeriodNotChosen: "Perioada nu este aleasa",
    ChooseDevicesForTechnician: "Asignare Aparate catre tehnicieni",
    ConfirmRemoveTechnician: "Sunteti sigur ca vreti sa stergeti tehnicianul din lista?",
    AddTechnician: "Adauga operator",
    EditTechnician: "Modifica operator",
    DeleteTechnician: "Sterge operator",
    NoTechniciansAddes: "Nu exista operatori asignati",
    ChangeTechnician: "Schimb informatii operator",
    MaintananceDays: "Zile alimentare",
    LastMaintanance: "Ultima alimentare",
    AddDevicesTo: "Adaugare Aparate la",
    IAccept: "Accept",
    IAgree: "Sunt de acord",
    AndIAgree: "Si sunt de acord cu",
    IDoNotAgree: "Nu sunt de acord",
    PleaseLogin: "Va rog, logati-va in sistem",
    ByReceipts: "Pe bonuri",
    ByItems: "Pe articole",
    ByQuantitiesPerHour: "Cantitati pe ora",
    ByPaymentTypes: "Pe moduri de plata",
    QuantitySold: "Cantitate vanduta",
    YouReceive: "Primiti",
    DailyReports: "Rapoarte zilnice",
    DailyReportsGrouped: "Rapoarte zilnice (grupate)",
    ZReport: "Raport Z",
    ZReports: "Rapoarte Z",
    ReportNumber: "Numar raport",
    MonthlyReports: "Rapoarte lunare",
    ReportsSales: "Rapoarte vanzari",
    Registration: "Inregistrare",
    Demo: "Demo",
    SendEmail: "Trimite e-mail",
    CurrentStatus: "Statu curent",
    DeviceLiveData: "Aparat date live",
    ReportsGrid: "Tabel raportari",
    ReportsChart: "Grafice raportari",
    MessageOther: "Alt tip",
    Mandatory: "Camp obligatoriu",
    NotValid: "Valoare invalida",
    NotValidEIK: "CUI invalid",
    Rules_Username: "Nume utilizator trebuie sa fie minim 3 caractere si maxim 30 caractere",
    InvalidEmail: "Adresa de e-mail invalida!",
    ProfileSettings: "Setari Profil",
    DistributorProfile: "Profil Distribuitor",
    ChooseFirm: "Alegere societate",
    ShowBalanceLog: "Afiseaza tranzactii cont",
    DateAccountCreated: "Data activare cont",
    PleaseChooseCustomer: "Va rog alege client",
    CustomerNotChosen: "Nu a fost ales client",
    NoCustomersToObserve: "Nu exista clienti care au asignat contul dumneavoastra pentru vizionare.",
    StatusOnlineDescription: "Aparatul este online, trimite regulat date catre serverul Tremol.",
    StatusOfflineDescription: "Aparatul este offline, a tecut o perioada indelugata de la ultima comunicatie cu serverul Tremol.",
    StatusBlockedDescription: "Aparat blocat. Verificati vendomatul sau contactati tehnicianul care se ocupa de automat.",
    StatusNoProfile: "Aparatul nu a comunicat niciodata cu serverul, contactati distribuitorul autorizat.",
    TheTermsOfUse: "Conditii de utilizare",
    RegistrationDataAvailable: "Ati completat date de inregistrare",
    RegistrationCancelConfirm: "Sunteti sigur ca vreti sa renuntati la inregistrare?",
    CopyCell: "Copiati continutul campului",
    TDatePicker_FromDateToDate: "De la data la data",
    TDatePicker_ChooseRange: "Alegere periaoda",
    TDatePicker_PleaseChooseRange: "Va rugam alegeti interval",
    TDatePicker_PleaseChooseEndDate: "Ati ales doar data de inceput, va rugam selectati si data de sfarsit",
    TDatePicker_RangeNotSet: "Nu at ales interval!",
    FilterDatePicker_FromHour: "De la ora",
    FilterDatePicker_ToHour: "Pana la ora",
    FiltersView_FiltersNotSet: "Nu ati introdus valoare pentru toate filtrele, va rugam corectati sau stergeti filtrele care nu au valoare",
    FilterChips_NoData: "Nu avem date pentru criteriul de filtrare",
    FilterNotChosen: "Nu ati ales camp pentru filtrare!",
    FilterInvalidForField: "Filter invalid pentru camp",
    DeviceEvents_NoEvents: "Nu exista evenimente",
    DeviceEvents_HasReached: "a ajuns",
    DeviceEvents_ReportsInFm: "raport MF",
    PleaseEnterUsername: "Va rog introduceti nume utilizator",
    EmailWithCodeSent: "Mesajul cu codul de recuperare a parolei este transmis cu succes!",
    PleaseInputCaptcha: "Introduceti codul generat pt. a continua",
    PleaseCheckEmail: "Verificat adresa de mail cu care sunteti inregistrat in sistem",
    Chart_Bar: "In trepte",
    Chart_Line: "Grafica lineara",
    Chart_Percent: "Procentual",
    Chart_View: "Arata  graficul",
    Chart_ShowLabels: "Arata etichetele",
    Chart_HideLabels: "Ascunde etichetele",
    Grid_EditInfoFor: "Redacteaza informatia pt",
    Grid_ShowOnTheMap: "Arata pe harta",
    Grid_Subscribe: "Activeaza tipul abonamentului",
    Grid_ChangePlan: "Madifica tipul abonamentului",
    Grid_DeactivatePlan: "Dezactiveaza  tipul abonamentului",
    Grid_InstructionOnWebsite: "Instructiuni de utilizare",
    Grid_DevsWithNoData: "Este conectat echipament pt care nu sunt date",
    Grid_TooManyDataConfirmExport: "Tabelul contine multa informatia si este posibil exportul sa dureze mai mult.Continuam",
    MenuDescription_Mailbox: "Sistem de informare a utilizatorului",
    MenuDescription_GridDevices: "Lista echipamentelor",
    MenuDescription_DevStatus: "Sinteza  a situatiei curente a echipamentelor",
    MenuDescription_DevRealTime: "Vizualizati datele aparate in timp real",
    MenuDescription_DevInfo: "Situatia amanutita al tutoror ecipamentelor produse de Tremol OOD ",
    MenuDescription_Alarms: "Evinimente active curente pt.echipamentele Dvs.",
    MenuDescription_MonthlyReports: "Prezentarea  in tabel a datelor din rapoartelor lunare al echipamentelor fiscale",
    MenuDescription_DailyReports: "Prezentarea in tabel datelor din rapoartelor zilnice al echpametelor fiscale",
    MenuDescription_DailyReportsGrouped: "Prezentarea in tabel totalizatorul datelor  rapoartelor zilnice al echpametelor fiscale",
    MenuDescription_Sales: "Prezentarea in tabel a datelor dela vanzarilor pe bonuri",
    MenuDescription_SalesByItems: "Prezentarea in tabel  a vanzarilor pe articole",
    MenuDescription_SalesByPrices: "Prezentarea in tabel a vanzarilor dupa preturi",
    MenuDescription_ChartMonthly: "Prezentarea grafica a datelor de larapoartelor lunare",
    MenuDescription_ChartDaily: "Prezentarea grafica  a datelor de la rapoartele zilnice",
    MenuDescription_ChartHourly: "Prezentarea grafica cifra de afaceri pe ore",
    MenuDescription_ChartHourlyQTY: "Prezentarea grafica a cantitatilor vandute pe ore",
    MenuDescription_ChartByPrice: "Prezentarea grafica a vanzarilor grupate dupa pretul unitar",
    MenuDescription_ChartPaymentsByDays: "Prezentarea grafica a tipurilor de plata pe zi",
    MenuDescription_Technicians: "Adaugati si editati o lista de persoane de asistenta",
    MenuDescription_Interface: "Configurati interfata aplicatiei",
    MenuDescription_Location: "O harta cu locatia fiecarui dispozitiv",
    Landing_EffectiveHelper: "Ajutor",
    Landing_ForYourBusiness: "pt.afacerea ta",
    Landing_CloudPlatform: "este platforma cloud pentru conectarea la distanta a aparatelor fiscale de vending.",
    Landing_ModernSolution: "O solutie moderna, care asigura managementul eficient si rapid a afacerii.",
    Landing_KeyAdvantages: "AVANTAJE IMPORTANTE",
    Landing_SalesDone: "vanzari efectuate",
    Landing_MostSoldItems: "cele mai vandute",
    Landing_Optimizing: "optimizare",
    Landing_Expenses: "cheltueli",
    Landing_Saving: "Economie",
    Landing_OnTime: "de timp",
    Landing_With: "Prin",
    Landing_WillAchieve: "veti obtine",
    Landing_BetterControl: "o conducerea mai efectiva a activitatii",
    Landing_StaffControl: "control a personalulului",
    Landing_Tracking: "urmarirea a",
    Landing_Sales: "vanzarilor",
    Landing_Analyze: "Analiza activitatii avand in vedere vanzarilor si volomul incasarilor",
    Landing_SubscriptionPlans: "TIPURI DE ABONAMENT",
    Landing_OurSubscriptionPlans: "TIPURILE NOASTRE DE ABONAMENT",
    Landing_RegisterAndReceive: "Iregistreaza te si vei primi doua luni gratuit pt serviciu",
    Landing_DiscountForDevs: "Reducere in functie de numarul de aparate reducere in functie de echipamente",
    Landing_ControlYourBusiness: "Conducetiva afacerea din miscare indiferent unde va aflati! Urmaresi afacerea ta ori unde te afli",
    Landing_ControlYourBusinessFromEverywhere: "Conducetiva afacerea din miscare indiferent unde va aflati!",
    Landing_MobileApp: "Folosind aplicatia mobila stiti in permanenta cum merge afacerea. Transformati-l in ajutor de nadejde si eliberati-va resursele pentru alte activitati. Urmariti usor tendintele in vanzari si cele mai vandute articole.",
    Landing_InstallMobile: "aplicatia se poate descarca gratuit din ",
    Landing_MayInstall: "Puteti instala aplicatia pe telefonul mobil",
    Landing_FromStore: "se poate descarca gratuit din Google Play Store.",
    Landing_ContactUs: "CONTACTATI-NE",
    Landing_RealTimeAnalisys: "Analiza in timp real",
    LoggedWithDemoAcc: "Sunteti autentificat cu un cont Demo care genereaza date aleatorii. Contul demo este complet functional si va puteti face o idee completa despre lucrul cu aplicatia.",
    Activity: "Actiune",
    Refresh: "Reimprospata",
  };

  static bg = {
    Locale: "bg",
    VAT_GROUP_COUNT: 4,
    VAT_GROUP_1: "А",
    VAT_GROUP_2: "Б",
    VAT_GROUP_3: "В",
    VAT_GROUP_4: "Г",
    MoneyAbbreviation: "лв.",
    MoneyAbbreviation2: "€",
    Currency: "Валута",
    HourAbbreviation: "ч.",
    Yes: "Да",
    No: "Не",
    OK: "ОК",
    Append: "Приложи",
    Clear: "Изчисти",
    More: "Още",
    Less: "По-малко",
    Error: "Грешка",
    Attention: "Внимание",
    Info: "Информация",
    Important: "Важно",
    Warning: "Предупреждение",
    Urgent: "Спешно",
    None: "Няма",
    Number: "Номер",
    Today: "Днес",
    Yesterday: "Вчера",
    TheWeek: "Седмицата",
    ThisMonth: "Този месец",
    PreviousMonth: "Миналия месец",
    IsBetween: "е между",
    Contains: "съдържа",
    Sales: "Продажби",
    SalesByItems: "Продажби по артикули",
    SalesByPrices: "Продажби по цени",
    SaleDate: "Дата на продажбата",
    PaymentTypesByDays: "Видове плащания по дни",
    PaymentType: "Тип плащане",
    PaymentSum: "Сума плащане",
    Receipts: "Бонове",
    ReceiptsCount: "Брой бонове",
    ReceiptNumber: "Номер бон",
    Article: "Артикул",
    Department: "Департамент",
    Backward: "Назад",
    Finish: "Завърши",
    Settings: "Настройки",
    Active: "Активна",
    Stopped: "Спряна",
    Forward: "Напред",
    Login: "Вход",
    Logging: "Вход в системата...",
    Logout: "Изход",
    View: "Изглед",
    Alarms: "Известия",
    Continue: "Продължи",
    Format: "Формат",
    Period: "Период",
    Columns: "Колони",
    Export: "Експорт",
    Download: "Изтегли",
    TaxGr: "Дан. гр.",
    TaxGroup: "Данъчна група",
    Turnover: "Оборот",
    SalesCount: "Брой транзакции",
    AverageDaily: "средно на ден",
    TurnoverByTaxGroups: "Оборот по данъчни групи",
    TurnoverByDays: "Оборот по дни",
    TurnoverByHours: "Оборот по часове",
    TurnoverByHoursForTheDay: "Оборот по часове за деня",
    ActivityByHours: "Натовареност по часове",
    TotalTurnover: "Общ оборот",
    Payments: "Плащания",
    Type: "Тип",
    Recipient: "Получател",
    Client: "Купувач",
    Address: "Адрес",
    Customer: "Клиент",
    CustomerMolName: "Имена на МОЛ на фирмата",
    ClientInfo: "Данни на клиента",
    VAT: "ДДС",
    ZDDS: "ЗДДС",
    IdentN: "Идент.N",
    FM: "ФП",
    UNP: "УНП",
    User: "Потребител",
    Username: "Потребителско име",
    Email: "Електронна поща",
    From: "От",
    To: "До",
    Value: "Стойност",
    Values: "Стойности",
    Add: "Добави",
    Total: "Общо",
    Subtotal: "Междинна сума",
    Addition: "Надбавка",
    Discount: "Отстъпка",
    Original: "Оригинал",
    ForInvoiceN: "КЪМ ФАКТУРА N",
    CreditNoteNumber: "КРЕДИТНО ИЗВЕСТИЕ N",
    ReceiptInfo: "Информация за бона",
    IssueReason: "Основание за издаване",
    Balance: "Баланс",
    NoBalance: "Недостатъчен баланс",
    CurrentBalance: "Текущ баланс",
    BalancePay: "Зареждане",
    Bonus: "Бонус",
    BonusAccumulated: "Натрупан бонус",
    BonusUnused: "Натрупан, неизползван бонус от Ваши Tremol Assistant плащания за клиенти.",
    BonusPayment: "Бонус зареждане на сметка",
    BalancePayment: "Зареждане на сметка",
    Charging: "Таксуване",
    ChargingDaily: "Дневно таксуване",
    Password: "Парола",
    CurrentPassword: "Текуща парола",
    ForgottenPassword: "Забравена парола",
    NewPassword: "Нова парола",
    ConfirmPassword: "Потвърди парола",
    Confirmation: "Потвърждение",
    ChangePassword: "Смяна на парола",
    Profile: "Профил",
    PasswordMin6Symbols: "Паролата трябва да е мимумум 6 символа",
    PasswordMin6Max30Symbols: "Паролата трябва да бъде минимум 6 и максимум 30 символа",
    PasswordRequired: "Моля, въведете парола",
    PasswordNewRequired: "Моля, въведете нова парола",
    PasswordsDoesntMatch: "Паролите не съвпадат!",
    PasswordChangedSuccessfully: "Успешна смяна на парола.",
    CompanyName: "Име на фирма",
    CompanyEIK: "Фирма ЕИК",
    MoneyInOut: "Служебна сума",
    InfoReceipt: "Информационен бон",
    Duplicate: "Дубликат",
    Storno: "Сторно",
    StornoReceipt: "Сторно бон",
    StornoTurnover: "Сторно оборот",
    CreditNode: "Кредитно известие",
    FUVASEvent: "ФУВАС събитие",
    FUVASButtonEvent: "ФУВАС бутон",
    DeviceStatus: "Статус на ФУ",
    AuditAuto: "Автоматичен одит",
    AuditInfoAuto: "Одит информация (Автоматична)",
    AuditInfoManual: "Одит информация (Ръчна)",
    FiscalizationReceipt: "Регистрационен бон",
    FiscalReceipt: "Фискален бон",
    LastReceipt: "Последен бон",
    AutoReload: "Автоматично опресняване на живи данни",
    Invoice: "Фактура",
    Document: "Документ",
    Legend: "Легенда",
    Sum: "Сума",
    EIK: "ЕИК",
    MOL: "МОЛ",
    MOLorAuthorizedPerson: "МОЛ или упълномощено лице",
    Price: "Цена",
    PriceForOne: "Единична цена",
    PriceForMonth: "Месечна цена на устройство",
    Date: "Дата",
    Hour: "Час",
    Quantity: "Количество",
    Void: "Корекция",
    Message: "Съобщение",
    V_O_I_D: "К О Р Е К Ц И Я",
    S_T_O_R_N_O: "С Т О Р Н О",
    Voided: "Анулиран",
    InCash: "В брой",
    Card: "Карта",
    TotalSum: "Обща сума",
    TOTALSUM: "ОБЩА СУМА",
    Operator: "Оператор",
    Operations: "Операции",
    Status: "Статус",
    Cancel: "Отказ",
    Search: "Търсене",
    Sort: "Сортирай",
    Subscription: "Абонамент",
    Activate: "Aктивиране",
    ActivatePlan: "Aктивиране на план",
    Deactivate: "Деактивиране",
    DeactivatePlan: "Деактивиране на план",
    CurrentPlan: "Текущ план",
    ConfirmRequest: "Потвърждение на заявката за",
    Comment: "Коментар",
    DevComment: "ФУ Коментар",
    Change: "Промени",
    Contract: "Договор",
    ContractTo: "Договор до",
    ActiveSim: "Активна SIM карта",
    Settlement: "Населено място",
    Street: "Улица",
    SubscriptionPlan: "Абонаментен план",
    ChangePlan: "Промяна на план",
    ChoosePlan: "Избор на абонаментен план",
    ChooseAll: "Избери всички",
    ChooseDevices: "Избор на устройства",
    SimStatus: "Статус SIM",
    Choice: "Избор",
    NoData: "Липсват данни",
    Data: "Данни",
    Filters: "Филтри",
    Action: "Действие",
    Dev: "ФУ",
    Device: "Устройство",
    Devices: "Устройства",
    AllDevices: "Всички устройства",
    AllDevs: "Всички ФУ",
    Product: "Продукт",
    Ingredient: "Съставка",
    ReceiptType: "Тип на бона",
    ReceiptDate: "Бон дата",
    FMNum: "Номер ФП",
    DevSN: "Сериен номер ФУ",
    FDRID: "FDRID",
    SN: "Сериен номер",
    KLEN: "КЛЕН",
    Event: "Събитие",
    Technician: "Поддръжка",
    Seen: "Видяно",
    DevNumber: "ФУ номер",
    Model: "Модел",
    Missing: "Липсва",
    Company: "Фирма",
    Name: "Име",
    Surname: "Презиме",
    LastName: "Фамилия",
    PSN: "Т.О.",
    PCS: "бр.",
    Description: "Описание",
    ItemName: "Име на артикул",
    DefaultItem1: "Кафе",
    DefaultItem2: "Чай",
    DefaultItem3: "Капучино",
    DefaultItem4: "Мляко",
    DefaultItem5: "Кроасан",
    DefaultItem6: "Вафла",
    DefaultItem7: "Солети",
    DefaultItem: "Кюфте",
    SearchSort: "Търсене / филтриране",
    SearchByNameOrSN: "Търсене по име или сериен номер",
    PSName: "Търговски обект",
    YearAndMonth: "Месец и година",
    Year: "Година",
    Month: "Месец",
    DayFromTheWeek: "Ден от седмицата",
    DevsCount: "Брой устройства",
    ChosenDevsFor: "Избрани устройства за",
    CurrentlyChosenDevs: "Текущо избрани устройства",
    TotalChosenDevs: "Общо абонирани устройства",
    TotalDevs: "Общо устройства",
    NothingChosen: "Не сте избрали нищо!",
    DataNotFound: "Не са намерени данни по търсения критерий",
    Device_Name: "Име на ФУ",
    Device_Info: "Информация за ФУ",
    CapsTooltip_CapsON: "Caps Lock е пуснат!",
    Online: "Онлайн",
    Offline: "Офлайн",
    NoSubscription: "Без абонамент",
    Blocked: "Блокирал",
    NoProfile: "Неактивен",
    BLOCK_TEXT: "Блокирал ФУВАС",
    FM_FULL_TEXT: "Препълнена ФП",
    FM_NEAR_FULL_TEXT: "Остават по-малко от 50 записа във ФП",
    ReceiveDate: "Дата на получаване",
    DGVColumnSelector_ChooseColumns: "Избор на колони",
    BlockedDevs: "Блокирали ФУВАС",
    Location: "Местоположение",
    Title: "Заглавие",
    Column: "Колона",
    Version: "версия",
    Phone: "Телефон",
    DarkMode: "Тъмен режим",
    DenseMode: "'Свит' режим на таблиците",
    ListDevs: "Списък ФУ",
    Save: "Запази",
    SaveChanges: "Запазване на промените",
    SaveSuccessful: "Успешен запис",
    AddSuccessful: "Успешно добавяне",
    EditSuccessful: "Успешна редакция",
    DeleteSuccessful: "Успешно премахване",
    EditInfo: "Редакция на информацията",
    ForTheDay: "За деня",
    ForTheWeek: "За седмицата",
    ForTheMonth: "За месеца",
    ForTheYear: "За годината",
    ReportReceipts: "Справка по бонове за деня",
    DevsWithoutSaleReports: "Този модел ФУ не поддържат дистанционно отчитане!",
    InnerMessages: "Входящи съобщения",
    DeviceList: "Списък с устройства",
    DeviceList_Sort: "Сортиране",
    DeviceList_ChooseAllDevs: "Избор на всички устройства",
    DeviceList_NoDevsFound: "Не са намерени устройства",
    DeviceList_AddressAsc: "Адрес възходящо ↓",
    DeviceList_AddressDesc: "Адрес низходящо ↑",
    DeviceList_NameAsc: "Име на ФУ възходящо ↓",
    DeviceList_NameDesc: "Име на ФУ низходящо ↑",
    DeviceList_SnAsc: "Сериен номер възходящо ↓",
    DeviceList_SnDesc: "Сериен номер низходящо ↑",
    DeviceInformation_DailyTurnoverAsc: "Дневен оборот възходящ ↓",
    DeviceInformation_DailyTurnoverDesc: "Дневен оборот низходящ ↑",
    DeviceInformation_WeeklyTurnoverAsc: "Седмичен оборот възходящ ↓",
    DeviceInformation_WeeklyTurnoverDesc: "Седмичен оборот низходящ ↑",
    DeviceList_NameAsc_mobile: "Име на ФУ ↓",
    DeviceList_NameDesc_mobile: "Име на ФУ ↑",
    DeviceList_SnAsc_mobile: "Сер. номер ↓",
    DeviceList_SnDesc_mobile: "Сер. номер ↑",
    DeviceInformation_DailyTurnoverAsc_mobile: "Дневен ↓",
    DeviceInformation_DailyTurnoverDesc_mobile: "Дневен ↑",
    DeviceInformation_WeeklyTurnoverAsc_mobile: "Седмичен ↓",
    DeviceInformation_WeeklyTurnoverDesc_mobile: "Седмичен ↑",
    PleaseChooseDevices: "Моля, изберете устройства",
    PleaseChooseTechnician: "Моля, изберете техник",
    LoadingOf: "Зареждане на",
    ForPeriod: "за период",
    PleaseWait: "моля, изчакайте...",
    LoadingView_LoadingInfo: "Зареждане на информация...",
    LoadingDataPleaseWait: "Зареждане на данни, моля, изчакайте...",
    LoadingReportsPleaseWait: "Зареждане на дневни отчети, моля, изчакайте...",
    LoadingSalesPleaseWait: "Зареждане на продажби за деня, моля, изчакайте...",
    LoadingLastSalesPleaseWait: "Зареждане на последните продажби, моля, изчакайте...",
    ExportingDataPleaseWait: "Данните се експортират, моля изчакайте...",
    ErrorOnExport: "Грешка при експортиране",
    ServerError: "Грешка от сървъра",
    ServerNoConnection: "Неуспешна връзка със сървъра.",
    ErrorUnknown: "Неизвестна грешка.",
    NoDevsSubscribed: "В момента нямате абонирани устройства",
    NoDevsSubscribedForThisData: "Няма устройства, които са абонирани за този тип данни.",
    PleaseSubscribeDevs: "Mоля, абонирайте устройствата, за които желаете да използвате услугата.",
    RedirectToSubscription: "Ще бъдете прехвърлени към меню 'Абонамент на ФУ', за да потвърдите активирането на устройствата.",
    RemainingTrialDays: "Дни от безплатният период",
    Notifications_Unread: "Непрочетени съобщения",
    Notifications_NoNotifications: "Няма известия",
    Picker_Chosen: "Избрани",
    PriceWithVat: "Цена с ДДС",
    SubscriptionPlan_PricePerDay: "лв. на ден",
    PricePerMonth: "лв. на месец",
    Captcha_WrongInput: "Грешно въведени стойности!",
    DevWithStoppedSim: "ФУ е със спряна SIM карта!",
    NoOnlineReports: "Този модел фискални устройства не поддържат дистанционно отчитане!",
    DataProcessingPleaseWait: "Данните се обработват, моля изчакайте...",
    LocationsFound: "Намерени локации",
    EditLocations: "Редакция на местоположенията",
    Map_DevInstruction: "Описание и инструкция за експлоатация.",
    Map_DevEditAddress: "Въвеждане на адрес.",
    Map_ShowInGoogleMaps: "Отвори в Google maps",
    Map_ClickAndEdit: "Кликнете върху картинката на съответното ФУ, задръжте бутона и преместете мишката, за да промените местоположението му.",
    LastActivity: "Последна активност",
    ZReportReceived: "Получен Z последните 3 дни",
    ZReportReceivedInLast3Days: "ФУ е изпратило Z отчет към Tremol Assistant в рамките на последните 3 ни.",
    ShowLastReceipt: "Покажи последния бон на ФУ",
    NewSale: "Нова продажба",
    NoFilteredDevsForActivating: "Няма устройства по въведените критерии, които подлежат на активиране.",
    NoFilteredDevsForDeactivating: "Няма устройства по въведените критерии, които подлежат на деактивиране.",
    NoDevsForActivating: "Няма устройства, които подлежат на абонамент.",
    NoDevsForDeactivating: "Няма устройства, подлежащи на прекратяване на абонамент.",
    PriceDailyFor: "Цена за ден за",
    PriceMonthlyFor: "Цена за 30 дни за",
    PriceYearlyFor: "Цена за 365 дни за",
    PriceFreeTrial: "Текуща цена през безплатния период",
    SendingSubscriptionRequestPleaseWait: "Изпращане на заявка за абонамент, моля изчакайте...",
    SuccessfulSubscription: "Успешна заявка за абонамент!",
    DiscountForDevCount: "Отстъпка за акаунт, спрямо брой абонирани ФУ",
    WhenSubscribing: "При абониране на",
    PercentDiscount: "Процент отстъпка",
    IfIPay: "Ако депозирам",
    PayedTo: "Платил до",
    ToWorkUntil: "За да работя до",
    PleaseChooseSubscriptionPlan: "Моля, изберете абонаментен план за поне едно устройство",
    TheBalanceWillBeUntil: "балансът ще ми стигне до",
    IsNecessaryToPay: "е необходимо да депозирам",
    DevPriceForDay: "Консумация на 1 ФУ за 1 ден",
    MonthlyPrice: "Месечна цена",
    ConsumptionForDay: "Консумация за ден",
    ConsumptionFor30Days: "Консумация за 30 дни (закръглена)",
    ConsumptionFor365Days: "Консумация за 365 дни (закръглена)",
    NoDataForShowing: "Няма данни за показване",
    NoInvoice: "Не е издадена фактура",
    ErrorWhileLoadingInvoice: "Грешка при зареждане на фактура",
    Read: "Прочетено",
    NotRead: "Непрочетено",
    MarkRead: "Маркирай прочетено",
    MarkNotRead: "Маркирай непрочетено",
    FilterBy: "Филтрирай по",
    FilterBySubject: "Филтрирай по тема",
    FilterByType: "Филтрирай по тип",
    NoMessagesReceived: "Нямате получени съобщения",
    NoMessagesFound: "Няма намерени съобщения.",
    ContactPhone: "Телефон за връзка",
    FuvasEvents: "ФУВАС събития",
    ShowClockWithDates: "Показвай часове при избор на период",
    ShowTooltips: "Показвай помощни балони",
    ExampleTooltip: "Примерен помощен балон",
    DontShowOldModels: "Не показвай стари модели ФУ",
    StartPage: "Начална страница",
    NotificationEmail: "E-mail за ФУВАС събития",
    InvalidPhone: "Невалиден телефон за връзка!",
    NoRecordsFound: "Няма открити записи",
    DevicesNotChosen: "Не са избрани устройства.",
    PeriodNotChosen: "Не е избран период.",
    ChooseDevicesForTechnician: "Избор на устройства, които лицето поддържа",
    ConfirmRemoveTechnician: "Сигурни ли сте, че искате да премахнете това лице за поддръжка от списъка?",
    AddTechnician: "Добавяне на лице за поддръжка",
    EditTechnician: "Редакция на лице за поддръжка",
    DeleteTechnician: "Премахване на лице за поддръжка",
    NoTechniciansAddes: "Не са добавени лица за поддръжка",
    ChangeTechnician: "Промени информация на лице за поддръжка",
    MaintananceDays: "Дни за обслужване",
    LastMaintanance: "Последно зареждане",
    AddDevicesTo: "Добавяне на устройства към",
    IAccept: "Приемам",
    IAgree: "Съгласен съм",
    AndIAgree: "и съм съгласен с тях",
    IDoNotAgree: "Не съм съгласен",
    PleaseLogin: "Моля, влезте в системата!!!",
    ByReceipts: "По бонове",
    ByItems: "По артикули",
    ByQuantitiesPerHour: "Количества по часове",
    ByPaymentTypes: "По видове плащания",
    QuantitySold: "Продадено количество",
    YouReceive: "Вие получавате",
    DailyReports: "Дневни отчети",
    DailyReportsGrouped: "Дневни отчети (сумирани)",
    ZReport: "Z отчет",
    ZReports: "Z отчети",
    ReportNumber: "Номер отчет",
    MonthlyReports: "Месечни отчети",
    ReportsSales: "Справки продажби",
    Registration: "Регистрация",
    Demo: "Демо",
    SendEmail: "Изпрати e-mail",
    CurrentStatus: "Текущо състояние",
    DeviceLiveData: "Живи данни",
    ReportsGrid: "Таблични справки",
    ReportsChart: "Графични справки",
    MessageOther: "Друг вид",
    Mandatory: "Задължително поле",
    NotValid: "Невалидна стойност",
    NotValidEIK: "Невалиден ЕИК",
    Rules_Username: "Потребителското име трябва да бъде минимум 3 и максимум 30 символа",
    InvalidEmail: "Невалидна електронна поща (e-mail)",
    ProfileSettings: "Настройки на профила",
    DistributorProfile: "Дистрибуторски профил",
    ChooseFirm: "Избор на фирма",
    ShowBalanceLog: "Покажи движенията по сметката ми",
    DateAccountCreated: "Дата на активиране на акаунта",
    PleaseChooseCustomer: "Моля изберете клиент",
    CustomerNotChosen: "Не е избран клиент",
    NoCustomersToObserve: "Все още няма клиенти, които са добавили акаунта Ви като наблюдател.",
    StatusOnlineDescription: "Устройството е онлайн, изпраща регулярно данни към сървъра на Тремол.",
    StatusOfflineDescription: "Устройството е офлайн, дълго време без комуникация със сървъра на Тремол.",
    StatusBlockedDescription: "Блокирал ФУВАС. Проверете вендинг машината на място или се свържете със сервиза обслужващ ФУ.",
    StatusNoProfile: "ФУ не е комуникирало никога със сървъра, моля свържете се с производителя.",
    TheTermsOfUse: "Общите условия",
    RegistrationDataAvailable: "Попълнили сте регистрационни данни.",
    RegistrationCancelConfirm: "Сигурни ли сте, че искате да се откажете от регистрацията?",
    CopyCell: "Копирай съдържанието на клетката",
    TDatePicker_FromDateToDate: "От дата - до дата",
    TDatePicker_ChooseRange: "Избор на период",
    TDatePicker_PleaseChooseRange: "Моля изберете период",
    TDatePicker_PleaseChooseEndDate: "Избрали сте само начална дата на диапазона, моля, изберете и крайна дата.",
    TDatePicker_RangeNotSet: "Не сте избрали период!",
    FilterDatePicker_FromHour: "От час",
    FilterDatePicker_ToHour: "До час",
    FiltersView_FiltersNotSet: "Не сте избрали стойности за всички филтри. Моля, коригирайте или премахнете съответните филтри.",
    FilterChips_NoData: "Липсват данни за този филтър",
    FilterNotChosen: "Не е избрано поле за филтриране!",
    FilterInvalidForField: "Невалиден филтър за поле",
    DeviceEvents_NoEvents: "Няма текущи известия",
    DeviceEvents_HasReached: "е достигнало",
    DeviceEvents_ReportsInFm: "отчета във фискалната памет",
    PleaseEnterUsername: "Моля, въведете потребителско име!",
    EmailWithCodeSent: "Писмото с кода за възстановяване на паролата е изпратено успешно!",
    PleaseInputCaptcha: "Моля въведете генерираният код, за да продължите напред.",
    PleaseCheckEmail: "Моля, провете си електронната пощата, с която сте се регистрирали в системата.",
    Chart_Bar: "Стълбовидно",
    Chart_Line: "Линейна графика",
    Chart_Percent: "Процентно",
    Chart_View: "Изглед на графиката",
    Chart_ShowLabels: "Покажи етикетите",
    Chart_HideLabels: "Скрий етикетите",
    Grid_EditInfoFor: "Редактирай информацията за",
    Grid_ShowOnTheMap: "Покажи на картата",
    Grid_Subscribe: "Активирай план за абонамент на",
    Grid_ChangePlan: "Промени план за абонамент на",
    Grid_DeactivatePlan: "Деактвирай план за абонамент на",
    Grid_InstructionOnWebsite: "Описание и инструкция за експлоатация на",
    Grid_DevsWithNoData: "Има устройства, за които все още няма данни",
    Grid_TooManyDataConfirmExport: "Таблицата съдържа много данни и е възможно временно 'зависване' на приложението при експорта. Да продължим ли с експортирането?",
    MenuDescription_Mailbox: "Уведомителна система на потребителя",
    MenuDescription_GridDevices: "Списък с устройствата на потребителя",
    MenuDescription_DevStatus: "Обобщена информация за текущото състояние на Вашите фискални устройства",
    MenuDescription_DevRealTime: "Информация за устройство в реално време",
    MenuDescription_DevInfo: "Подробна информация за всички Ваши устройства, произведени от Тремол ООД",
    MenuDescription_Alarms: "Текущите активни събития за устройствата Ви",
    MenuDescription_MonthlyReports: "Таблично представяне на данните от месечните отчети на фискалните устройства",
    MenuDescription_DailyReports: "Таблично представяне на данните от дневните (Z) отчети на фискалните устройства",
    MenuDescription_DailyReportsGrouped: "Таблично представяне на сумираните данни от дневните (Z) отчети на фискалните устройства",
    MenuDescription_Sales: "Таблично представяне на данните от продажбите по бонове",
    MenuDescription_SalesByItems: "Таблично представяне на продажбите по артикули",
    MenuDescription_SalesByPrices: "Таблично представяне на продажбите по цени",
    MenuDescription_ChartMonthly: "Графично представяне на данните от месечните отчети",
    MenuDescription_ChartDaily: "Графично представяне на данните от дневните (Z) отчети",
    Landing_EffectiveHelper: "Ефективен помощник",
    Landing_ForYourBusiness: "за твоя бизнес",
    Landing_CloudPlatform: "е облачна платформа за дистанционна връзка с вашите фискални устройства.",
    Landing_ModernSolution: "Едно модерно решение, осигуряващо свобода на действие и лесно управление на бизнеса.",
    Landing_KeyAdvantages: "КЛЮЧОВИ ПРЕДИМСТВА",
    Landing_SalesDone: "извършени продажби",
    Landing_MostSoldItems: "най-продавани стоки",
    Landing_Optimizing: "опитмизиране",
    Landing_Expenses: "на разходи",
    Landing_Saving: "Спестяване",
    Landing_OnTime: "на време",
    Landing_With: "Чрез",
    Landing_WillAchieve: "ще постигнете",
    Landing_BetterControl: "по-добро управление на търговския обект",
    Landing_StaffControl: "контрол на персонала",
    Landing_Tracking: "проследимост на",
    Landing_Sales: "продажбите",
    Landing_Analyze: "Анализирате дейността си в детайли, спрямо извършените продажби и натрупани обороти с",
    Landing_SubscriptionPlans: "МЕСЕЧНИ ПЛАНОВЕ",
    Landing_OurSubscriptionPlans: "НАШИТЕ МЕСЕЧНИ АБОНАМЕНТНИ ПЛАНОВЕ",
    Landing_RegisterAndReceive: "Регистрирайте се и ще получите двумесечен безплатен достъп до услугата",
    Landing_DiscountForDevs: "Отстъпка до 50% за повече активирани устройства",
    Landing_ControlYourBusiness: "Управлявайте бизнеса си в движение!",
    Landing_ControlYourBusinessFromEverywhere: "Управлявайте бизнеса си в движение, независимо къде се намирате!",
    Landing_MobileApp:
      "С мобилното приложение имате поглед върху бизнеса си в реално време. Превърнете го в свой верен помощник и си осигурете свобода на действие, без ограничения на място и време. Следете лесно тенденциите в продажбите си, най-продаваните стоки, дневните и месечните обороти.",
    Landing_InstallMobile: "Може да инсталирате безплатно мобилното приложение от",
    Landing_MayInstall: "Може да инсталирате приложението на мобилното си устройство",
    Landing_FromStore: "като го изтеглите безплатно от Google Play Store.",
    Landing_ContactUs: "СВЪРЖЕТЕ СЕ С НАС",
    Landing_RealTimeAnalisys: "Анализ в реално време",
    Landing_ContactsMobile: "Мирослава Георгиева - 0894 699 131",
    Landing_Contacts: "Мирослава Георгиева - 089 469 9131\nСтанислава Павлова - 088 704 4288\nСветлозар Георгиев - 089 435 9988",
    LoggedWithDemoAcc: "Влезли сте с Демо акаунт, който генерира случайни данни. Демо акаунтът е напълно функционален и може да придобиете цялостна представа за работа с приложението.",
    FreeOfChargePeriod:
      "По време на безплатния двумесечен период, в който се намирате, можете да абонирате всички Ваши устройства и да се възползвате от услугата напълно безплатно.\n\tЩе бъдете прехвърлени към меню 'Абонамент на ФУ', за да потвърдите активирането на устройствата.",
    DataIsRefreshingByItself: "Данните в приложението се опресняват автоматично и няма нужда да излизате и влизате отново.\nАко желаете да излезете от приложението, моля използвайте бутона Изход.",
    Activity: "Активност",
    Refresh: "Опресняване",
  };
  static md = {};
  static lang = Object.assign({}, Translation.bg);

  static setLang = (lang) => {
    Translation.lang = Translation[lang];
    // console.log("translation lang = " + lang + " " + Translation.lang.Locale);
    // console.log(TR.Locale);
  };
  

  static g_euroDate = new Date(2026, 0, 1).addMilliseconds(-1); //TODO !!!!!!!!!!!!!!!!!!!!!!
  static g_isEuro = false;
}

var now = new Date();
if(now.getTime() > Translation.g_euroDate.getTime()) {
  console.log("EURO! " + Translation.g_euroDate.toString());
  Translation.g_isEuro = true;
  Translation.bg.MoneyAbbreviation = "€";
  Translation.bg.MoneyAbbreviation2 = "лв.";
  Translation.bg.SubscriptionPlan_PricePerDay = "€ на ден";
  Translation.bg.PricePerMonth = "€ на месец";
  Translation.lang = Object.assign({}, Translation.bg);
}


Translation.md = Object.assign({}, Translation.ro);
Translation.md.Locale = "md";
Translation.md.MoneyAbbreviation = "lei";
Translation.md.VAT_GROUP_COUNT = 4;

export default Translation;
